import React from 'react';
import PropTypes from 'prop-types';

import { SCOPES } from '@techchange/components';

import usePaginatedPointTotals from '../hooks/usePaginatedPointTotals';

import PointsNavDropdownMenu from './PointsNavDropdownMenu';

const DROPDOWN_MENU_DOM_ID = 'points-nav-item-dropdown-menu';

const propTypes = {

	/**
	 * The current user.
	 */
	currentUser: PropTypes.shape({

		/**
		 * The user's ID.
		 */
		id: PropTypes.string.isRequired,

	}).isRequired,

	/**
	 * The point label for the organization.
	 */
	pointLabel: PropTypes.shape({

		/**
		 * The point label id.
		 */
		id: PropTypes.string,

		/**
		 * The singular label.
		 */
		singular_label: PropTypes.string,

		/**
		 * The plural label.
		 */
		plural_label: PropTypes.string,

	}),

	/**
	 * The org-wide point total for the current user and organization.
	 */
	orgPointTotal: PropTypes.shape({

		/**
		 * The value of the point total.
		 */
		total: PropTypes.number,

		/**
		 * The scope of the point total.
		 */
		scope: PropTypes.oneOf([SCOPES.ORGANIZATION]).isRequired,

	}),

};

const PointsNavDropdown = ({ currentUser, pointLabel, orgPointTotal }) => {

	// Keep track of all the session-by-session point totals for the user
	// (on dropdown menu opened for first time)
	const [
		sessionPointTotals,
		sessionPointTotalsError,
		sessionPointTotalsLoadState,
		fetchSessionPointTotals
	] = usePaginatedPointTotals({
		scope: SCOPES.SESSION,
		user_id: currentUser.id,
		include: ['sessions'],
	}, DROPDOWN_MENU_DOM_ID);

	return (
		<PointsNavDropdownMenu
			currentUser={currentUser}
			pointLabel={pointLabel}
			orgPointTotal={orgPointTotal}
			sessionPointTotals={sessionPointTotals}
			showError={sessionPointTotalsError}
			menuLoadState={sessionPointTotalsLoadState}
			onLoadMenuData={fetchSessionPointTotals} />
	);

};

PointsNavDropdown.propTypes = propTypes;

export default PointsNavDropdown;
